"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function findScrollableElement(target, knownScrollingElements = []) {
    let currentEl = target;
    const body = document.body;
    while (currentEl && currentEl !== body) {
        if (knownScrollingElements.indexOf(currentEl) > -1) {
            return currentEl;
        }
        currentEl = currentEl.parentElement;
    }
    return null;
}
exports.default = findScrollableElement;
//# sourceMappingURL=findScrollableElement.js.map